import { combineReducers } from 'redux';

import { createReducer } from '../../utils/createReducer';
import { chatRoutine, chatSendRoutine } from '../routines/chatRoutine';

export default combineReducers({
  chats: createReducer(chatRoutine, "chats"),
  chatSend: createReducer(chatSendRoutine, "chatSend"),
});
